import styled from '@emotion/styled/macro';
import background_image from 'assets/background.webp';
// import { Box } from '@chakra-ui/react';

export const Background = styled.div`
  background-image: url(${background_image});
  background-size: cover;
  background-position: center;
  height: 100vh;
`;
